// extracted by mini-css-extract-plugin
export default {"checkbox":"checkbox_checkbox__BBgeO","text":"checkbox_text__JROQf"};